import request from 'utils/request';
import config from 'config/Config';

export default class {
  // 获取客户列表
  static getCustomerList(params) {
    return request({
      host: config.HOST_PROMOTE,
      url: 'customer/getMyCustomerList',
      params
    });
  }

  // 新建日程
  static updateTask(params) {
    return request({
      host: config.HOST_PROMOTE,
      url: `agenda/addOrUpdate`,
      method: 'post_json',
      data: params
    });
  }

  // 获取日程详情
  static getDetail(params) {
    return request({
      host: config.HOST_PROMOTE,
      url: `agenda/detail/get`,
      params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Promote/Schedule/NewAdd/NewAddServ.js